class BaseMap {
  static other = (isHaiTao) => ''
  static get (key, isHaiTao) {
    if (this.hasOwnProperty(key) && this[key] instanceof Function) return this[key](isHaiTao)
    else return this.other(isHaiTao)
  }
}

// 商品名称
export class itemNameTooltipMap extends BaseMap {
  static 3 = (isHaiTao) => isHaiTao ?'商品名称生成由：商品品牌+商品系列+商品材质+类型（隐形眼镜/彩色隐形眼镜）+更换周期+规格内容组成，如系列是无，则过滤':'商品名称生成由：商品品牌+商品系列+商品材质+类型（隐形眼镜/彩色隐形眼镜）+更换周期+规格内容组成，如系列是无，则过滤'
  static 5 = (isHaiTao) => isHaiTao ? '商品名称生成由：商品品牌+商品系列+类型（软镜隐形眼镜护理液/硬镜隐形眼镜护理液）+规格内容组成' : '商品名称生成由：商品品牌+商品系列+类型（软镜隐形眼镜护理液/硬镜隐形眼镜护理液）+规格内容组成，如系列是无，则过滤'
  static 7 = (isHaiTao) => isHaiTao ? '商品名称生成由：商品品牌+商品系列+类型（软镜隐形眼镜润眼液/硬镜隐形眼镜润眼液）+规格内容组成' : '商品名称生成由：商品品牌+商品系列+类型（软镜隐形眼镜润眼液/硬镜隐形眼镜润眼液）+规格内容组成，如系列是无，则过滤'
  static 21 = (isHaiTao) => isHaiTao ? '商品名称生成由：商品品牌+商品系列+商品类别（洗眼液）+规格内容组成' : '商品名称生成由：商品品牌+商品系列+商品类别（洗眼液）+规格内容组成，如系列是无，则过滤'
  static 13 = (isHaiTao) => isHaiTao ? '比如：趴趴熊 Colorful Life彩色生活系列时尚框架眼镜 217' : '比如：趴趴熊 Colorful Life彩色生活系列时尚框架眼镜 217'
  static other = (isHaiTao) => isHaiTao ? '比如：趴趴熊时尚框架眼镜 Colorful Life彩色生活系列 217' : '比如：趴趴熊时尚框架眼镜 Colorful Life彩色生活系列 217'
}

export class itemNamePlaceholderMap extends BaseMap {
  static 3 = (isHaiTao) => '系统自动生成'
  static 5 = (isHaiTao) => '系统自动生成'
  static 7 = (isHaiTao) => '系统自动生成'
  static 21 = (isHaiTao) => '系统自动生成'
  static other = (isHaiTao) => '请输入'
}

//  商品系列提示文案
export class itemSeriesTooltipMap extends BaseMap {
  static 5 = (isHaiTao) => '比如：海昌水赋能护理液，请填写“水赋能”；海昌草本物语多效护理液，请填写“草本物语多效”；没有请填写“无”'
  static 7 = (isHaiTao) => '比如：科莱博小黑裙隐形眼镜润眼液，请填写“小黑裙”；没有请填写“无”'
  static 21 = (isHaiTao) => '比如：拉拜诗矢车菊洗眼液，请填写“矢车菊”；没有请填写“无”'
  static other = (isHaiTao) => '举例：人鱼姬的金粉系列拉拜诗的伞语系列；没有请填写：无'
}
// 商品系列输入提示
export class itemSeriesPlaceholderMap extends BaseMap {
  static 3 = (isHaiTao) => '例如伞语'
  static 5 = (isHaiTao) => '例如水赋能'
  static 7 = (isHaiTao) => '例如小黑裙'
  static 21 = (isHaiTao) => '例如矢车菊'
  static other = () => '例如伞语'
}



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/constant.js